import { motion } from 'framer-motion'

const IndustryCard = ({ industry }) => {
  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      className="bg-white rounded-2xl shadow-xl overflow-hidden card-hover"
    >
      <div className="h-56 bg-gradient-to-br from-green-600 to-green-700 flex items-center justify-center relative overflow-hidden">
        <div className="absolute inset-0 moroccan-pattern opacity-10"></div>
        <span className="text-8xl relative z-10">{industry.icon}</span>
      </div>
      <div className="p-8">
        <h3 className="text-3xl font-bold text-gray-900 mb-4">{industry.name}</h3>
        <p className="text-gray-600 leading-relaxed mb-6">{industry.description}</p>
        <div className="space-y-3">
          <h4 className="font-bold text-gray-900 text-lg">Avantages Clés:</h4>
          <ul className="space-y-2">
            {industry.benefits.map((benefit, index) => (
              <li key={index} className="flex items-start gap-3">
                <span className="text-green-600 mt-1">✓</span>
                <span className="text-gray-700">{benefit}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </motion.div>
  )
}

export default IndustryCard